import { createPopupReducerAndActionCreators } from '@paragon/popup-state';

import type { PopupOptionsMap } from '../actions/popup';

export const { popupReducer: popup, showPopup } = createPopupReducerAndActionCreators<PopupOptionsMap>();
